import { isCoreXQuery } from '@gig/magic-common';
import { USER_LOGGED_IN_UPDATED, AML_STATUS_UPDATED, ACCOUNT_BLOCKS_UPDATED, ACCOUNT_BLOCKS_QUERY, ACCOUNT_REQUIRES_VERIFICATION_UPDATED, ACCOUNT_REQUIRES_VERIFICATION_QUERY, ACCOUNT_USER_VERIFICATION_OVERRIDE, COREX_AML_STATUS_QUERY } from '@gig/magic-messages';
import { __awaiter, __generator } from 'tslib';
import { magic } from '@gig/magic-sdk';
import { ActiveBlockReasonId, ActiveBlockReason } from '@gig/magic-sdk/dist/adapter/users/getUserActiveBlocks';
import { fetchUserDocuments, shouldBlockUser } from '../../utils/kyc-corex.js';

var AccountService = /** @class */ (function () {
    function AccountService() {
        var _this = this;
        this.isLoggedIn = false;
        this.blocks = [];
        this.requiresVerification = false;
        this.requiresVerificationSubscription = null;
        this.accountBlocksSubscription = null;
        this.loading = false;
        this.isCoreX = false;
        this.accountHandler = function () { return __awaiter(_this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.loading) {
                            return [2 /*return*/];
                        }
                        this.unsubscribeQueries();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.loading = true;
                        return [4 /*yield*/, this.updateUserBlocks()];
                    case 2:
                        _a.sent();
                        this.publishBlocksAndRequiresVerification();
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        // eslint-disable-next-line no-console
                        console.log('unable to update user block', e_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.loading = false;
                        this.subscribeToQueries();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        isCoreXQuery().then(function (isCoreX) {
            _this.isCoreX = isCoreX;
            _this.registerEvents();
            _this.subscribeToEvents();
            _this.overrideUserVerificationFlag();
        });
    }
    AccountService.prototype.subscribeToEvents = function () {
        var _this = this;
        window.eventBus.subscribe(USER_LOGGED_IN_UPDATED, function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoggedIn = !!e.payload;
                        if (!this.isLoggedIn) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.accountHandler()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.blocks = [];
                        this.requiresVerification = false;
                        this.publishBlocksAndRequiresVerification();
                        this.subscribeToQueries();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); }, { replay: true });
        window.eventBus.subscribe(AML_STATUS_UPDATED, function () {
            return _this.accountHandler();
        }, { replay: true });
    };
    AccountService.prototype.registerEvents = function () {
        window.eventBus.register(ACCOUNT_BLOCKS_UPDATED, {
            type: 'array',
        });
        window.queryBus.register(ACCOUNT_BLOCKS_QUERY, {
            type: 'array',
        });
        window.eventBus.register(ACCOUNT_REQUIRES_VERIFICATION_UPDATED, {
            type: 'boolean',
        });
        window.queryBus.register(ACCOUNT_REQUIRES_VERIFICATION_QUERY, {
            type: 'boolean',
        });
        window.commandBus.register(ACCOUNT_USER_VERIFICATION_OVERRIDE, {
            type: 'boolean',
        });
    };
    AccountService.prototype.updateUserBlocks = function () {
        return __awaiter(this, void 0, void 0, function () {
            var compliance, documents, hasBlocks, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.isCoreX) return [3 /*break*/, 3];
                        return [4 /*yield*/, window.queryBus.query(COREX_AML_STATUS_QUERY)];
                    case 1:
                        compliance = _b.sent();
                        return [4 /*yield*/, fetchUserDocuments()];
                    case 2:
                        documents = _b.sent();
                        hasBlocks = compliance
                            ? shouldBlockUser(compliance, documents)
                            : false;
                        if (hasBlocks) {
                            this.blocks = [
                                {
                                    userBlockId: 0,
                                    blockReasonId: ActiveBlockReasonId.UserNotVerified,
                                    blockReason: ActiveBlockReason.UserNotVerified,
                                    blockTypeId: 0,
                                    comment: '',
                                    blockType: '',
                                    startDate: '',
                                    endDate: '',
                                    cooldownEndDate: '',
                                    expireAutomatically: true,
                                    canBeCancelled: true,
                                    createdDate: '',
                                    createdBy: 0,
                                },
                            ];
                        }
                        else {
                            this.blocks = [];
                        }
                        return [3 /*break*/, 6];
                    case 3:
                        if (!!this.isLoggedIn) return [3 /*break*/, 4];
                        this.blocks = [];
                        return [3 /*break*/, 6];
                    case 4:
                        _a = this;
                        return [4 /*yield*/, magic.methods.users.getUserActiveBlocks()];
                    case 5:
                        _a.blocks = _b.sent();
                        _b.label = 6;
                    case 6:
                        this.requiresVerification = this.blocks.some(function (_a) {
                            var blockReasonId = _a.blockReasonId;
                            return blockReasonId === ActiveBlockReasonId.UserNotVerified;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AccountService.prototype.publishBlocksAndRequiresVerification = function () {
        window.eventBus.publish(ACCOUNT_REQUIRES_VERIFICATION_UPDATED, this.requiresVerification);
        window.eventBus.publish(ACCOUNT_BLOCKS_UPDATED, this.blocks);
    };
    AccountService.prototype.overrideUserVerificationFlag = function () {
        var _this = this;
        window.commandBus.subscribe(ACCOUNT_USER_VERIFICATION_OVERRIDE, function (event) {
            _this.requiresVerification = !!event.payload;
            _this.publishBlocksAndRequiresVerification();
        });
    };
    AccountService.prototype.subscribeToQueries = function () {
        var _this = this;
        if (!this.requiresVerificationSubscription) {
            this.requiresVerificationSubscription = window.queryBus.subscribe(ACCOUNT_REQUIRES_VERIFICATION_QUERY, function () {
                return _this.isLoggedIn && _this.requiresVerification;
            });
        }
        if (!this.accountBlocksSubscription) {
            this.accountBlocksSubscription = window.queryBus.subscribe(ACCOUNT_BLOCKS_QUERY, function () {
                return _this.blocks;
            });
        }
    };
    AccountService.prototype.unsubscribeQueries = function () {
        var _a, _b;
        (_a = this.requiresVerificationSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this.requiresVerificationSubscription = null;
        (_b = this.accountBlocksSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
        this.accountBlocksSubscription = null;
    };
    return AccountService;
}());

export { AccountService };
